import {setSnackbarDispatch, SnackbarActionTypes} from "../context/SnackBarContext";

export class SnackbarHelper {

    constructor(snackbar) {
        this.snackbar = snackbar;
    }

    showSuccessMessage(message = "") {
        this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, message))
    }

    showErrorMessage(message = "") {
        this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, message))
    }

    showWarningMessage(message = "") {
        this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
    }

    showInfoMessage(message = "") {
        this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_INFO, message))
    }

    showDefaultMessage(message = "") {
        this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_DEFAULT, message))
    }
}